import { Benchmark, ProgramStatus } from '@cibo/core'
import { BenchmarkStatusReasons } from '@cibo/programs'
import { ResponsiveDialog } from '@cibo/ui'
import Done from '@mui/icons-material/Done'
import Error from '@mui/icons-material/Error'
import HelpOutline from '@mui/icons-material/HelpOutline'
import { Backdrop, Button, DialogActions, DialogContent, IconButton } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

interface ProgramStatusIconProps {
  benchmark: Benchmark
  status: ProgramStatus
}

export const ProgramStatusIcon = ({ benchmark, status }: ProgramStatusIconProps) => {
  const { t } = useTranslation('ProgramStatusIcon')
  const [open, setOpen] = useState(false)

  const benchmarkStatus = status.benchmarks.find(s => s.benchmark === benchmark)

  if (!benchmarkStatus) {
    return null
  }

  return (
    <>
      <IconButton
        onClick={e => {
          e.stopPropagation()
          setOpen(true)
        }}
        disabled={benchmarkStatus.status === 'pass'}
      >
        {benchmarkStatus?.status === 'pass' ? (
          <Done color="success" />
        ) : benchmarkStatus?.status === 'fail' ? (
          <Error color="error" />
        ) : (
          <HelpOutline color="warning" />
        )}
      </IconButton>
      <ResponsiveDialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        slots={{
          backdrop: () => (
            <Backdrop
              open={open}
              onClick={e => {
                e.stopPropagation()
                setOpen(false)
              }}
            />
          ),
        }}
        fullWidth
      >
        <DialogContent>
          <BenchmarkStatusReasons reasons={benchmarkStatus.reasons} />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={e => {
              e.stopPropagation()
              setOpen(false)
            }}
            fullWidth={false}
          >
            {t('ok')}
          </Button>
        </DialogActions>
      </ResponsiveDialog>
    </>
  )
}
